import base from './base';
const lightTheme = {
  primary: '#000',
  'primary-hover': '#000000af',
  secondary: '#fff',
  'secondary-hover': '#ffffff6e',
  'app-color': '#314DDF',

  'text-color': '#111',
  'text-color-hover': '#888',
  'text-color-light': 'rgba(77, 77, 77, 1)',
  'text-color-xlight': '#888',
  'text-color-xxlight': 'rgba(5, 5, 5, 0.35)',

  'text-contrast': '#fff',

  'bg-color': '#fff',
  'bg-color-card': 'rgba(0, 0, 0, 0.055)',
  'review-card-bg-color': '#FAFAFA',

  expandable_category_wrapper_bg: '#transparent',

  'box-shadow-color': 'rgba(0, 0, 0, 0.75)',
  'border-color': '#E7E7E9',

  'input-bg-color': 'transparent',
  'input-border-color': '#E7E7E9',

  'user-navigation-bottom-border': '#E7E7E9',

  'not-eligible-text-color': 'rgba(114, 132, 255, 0.7)',
  'bottomBar-bg': 'rgba(231, 234, 255, 1)',

  'search-bar-container-bg': 'transparent',
  'search-bar-logo-bg': '#B2B2B2',
  'search-result-bg': '#fff',

  'filter-dropdown-bg': '#fff',

  'dropdown-color': '#314ddf',
  'dropdown-bg-color': '#E7EAFF',

  'like-bg-color': 'rgba(0, 186, 124, 0.1)',
  'dislike-bg-color': 'rgba(255, 232, 232, 0.6)',

  'protocol-bg': 'rgba(231, 234, 255, 0.3)',
  'protocol-text-color': 'rgba(114, 132, 255, 0.7)',

  'table-container-border': '#e5e7eb',
  'table-container-bg': 'rgba(231, 234, 255, 0.5)',
  'table-container-row-bg': '',

  'color-supertake-text': '#111',

  'text-editor-box-shadow':'rgba(70, 95, 241, 0.1)',

  'project-review-bg': 'rgba(231, 234, 255, 0.2)',

  'project-selected-bg': '#e7eaff',

  'dropdown-hover-color': 'rgba(231, 234, 255, 0.5)',

  'negative-text-color': '#fff',

  'button-bg-color': '#e9e9ed',
  'button-bg-color-hover': '#d0d0d7',
  'button-bg-color-dark': '#d1d1d1',
  'button-bg-color-dark-hover': '#d1d1d1b6',

  'skeleton-base-color': '#E7EAFF',
  'skeleton-highlight-color': '#dce1fc',

  'toggle-bg-color': 'rgba(0, 0, 0, 0.425)',
  'navbar-tab-bg': 'transparent',
  'reaction-bg': 'transparent',
  'reaction-border-like': 'rgba(21, 156, 74, 0.4)',
  'reaction-border-dislike': 'rgba(199, 41, 41, 0.4)',
  'like-fill-color': 'rgba(152, 229, 108, 0.60)',
  'dislike-fill-color': 'rgba(255, 88, 88, 0.60)',

  ...base,
};
export default lightTheme;
